import { inject } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';
import { SupabaseService } from '../services/supabase.service';
import { isTekmeghaSuperAdmin } from '../constants/super-admin-enquiries.util';

export const superAdminEnquiriesGuard: CanActivateFn = async () => {
  const supabaseService = inject(SupabaseService);
  const router = inject(Router);

  try {
    const session = await supabaseService.getSession();
    const userId = session?.data?.session?.user?.id;
    if (isTekmeghaSuperAdmin(userId)) {
      return true;
    }
  } catch {
    // fall through to redirect
  }

  void router.navigate(['/profile']);
  return false;
};
